// import React from 'react';
// import translations from '../../utils/language/translations.json'
// import { useTranslation } from 'react-i18next';
// function ConfirmationModal({ isVisible, onCancel, onConfirm, message }) {
//   const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
//   const currentLang = i18n.language; // Access the current language
//   const t = (key) => translations.CardGrid[key][currentLang]; // Adjust the path according to your JSON structure
 
//   if (!isVisible) {
//     return null;
//   }

//   return (
//     <div className="confirmation-modal">
//       <p>{message}</p>
//       <div className='flex-h' style={{display:'flex',justifyContent:'space-evenly',maxHeight:'55px'}}>
//       <button onClick={onConfirm}>{t('Yes')}</button>
//       <button onClick={onCancel}>{t('No')}</button>
//       </div>
//     </div>
//   );
// }

// export default ConfirmationModal;
import React from "react";
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";


function ConfirmationModal({ isVisible, onCancel, onConfirm, message, children }) {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.CardGrid[key][currentLang];

  return (
    <div className={`confirmation-modal ${isVisible ? "open" : "closed"}`}>
      <div className="modal-content">
        <p className="modal-message">{message}</p>

        {/* Dynamically Render Additional Content (e.g., Input Field) */}
        {children}

        <div className="btns">
          <button className="confirm-btn" onClick={onConfirm}>{t("Yes")}</button>
          <button className="cancel-btn" onClick={onCancel}>{t("No")}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
